import { useCallback } from "react";

export default function useInstantScroll() {
 const jumpToHash = useCallback((hash) => {
  const html = document.documentElement;
  // const prev = html.style.scrollBehavior;

  // Disable smooth scrolling
  html.style.scrollBehavior = "auto";

  // Find the element with this id/hash
  const element = document.querySelector(hash);

  if (element) {
    // Scroll to it directly (this always runs, even if hash is the same)
    element.scrollIntoView({ behavior: "auto", block: "start" });

    // Keep the URL hash in sync (only if it changed)
    if (window.location.hash !== hash) {
      window.location.hash = hash;
    }
  }

  // Restore previous scroll behavior
  // requestAnimationFrame(() => {
  //   html.style.scrollBehavior = prev || "";
  // });
}, []);


  // Return to the top of the document

    const jumpToTop = useCallback(() => {
    const html = document.documentElement;
    // const prev = html.style.scrollBehavior;

    html.style.scrollBehavior = "auto";

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    // requestAnimationFrame(() => {
    //   html.style.scrollBehavior = prev || "";
    // });
  }, []);

  return { jumpToHash, jumpToTop };
}
